import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { AgendaService } from 'app/main/services/agenda.service';
import { EventsService } from 'app/main/services/events.service';
import { NotificationService } from 'app/main/services/notification.service';
import { WebSocketService } from 'app/main/services/webSocket.service';
import { AlertComponentComponent } from 'app/main/shared/alert/alert-component/alert-component.component';
import { AuthService } from 'app/main/shared/services/auth.service';
import { LoaderService } from 'app/main/shared/services/loaderService.service';
import { LocalAccountService } from 'app/main/shared/services/localAccount.service';
import { navigation } from 'app/navigation/navigation';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    data: any;
    banca: any;
    role: any;
    primaryPath: string;
    secondaryPath: string;

    subPollingSession: Subscription;
    pollingInterval: any = null;

    notifications: any[];
    notificationsNumber: any;

    showVideoCallNotifications: boolean;
    videoCallNotifications: any[];
    videoCallNotificationsNumber: any;

    /*
    VIDEO CALL VARIABLES
    */
    showVideoCall: boolean;
    videoCallOperatorContactId: any;
    videoCallSocketSessionId: any;
    userSubjectAvailabilityId: any;
    purchasedSalesPackageId: any;
    videoCallOperatorIsAnswer: string;
    videoCallContactId: any;
    videoCallEmergencyId: any;
    videoCallId: any;
    callId: any;
    audio: HTMLAudioElement;
    callingTimeout: any;
    eventsSub: Subscription;
    eventsWebSocketSub: Subscription;
    isCalling: boolean;
    callDialog: any;
    operators: any[];
    myUserUuid: any;
    showProfileButton: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private auth: AuthService,
        private notificationService: NotificationService,
        private localAccountService: LocalAccountService,
        private webSocketService: WebSocketService,
        private loaderService: LoaderService,
        private dialog: MatDialog,
        private eventsService: EventsService,
        private agendaService: AgendaService
    ) {
        this.showProfileButton = true;
        this.showVideoCallNotifications = false;
        this.operators = [];
        this.notifications = [];
        this.notificationsNumber = 0;
        this.videoCallNotifications = [];
        this.videoCallNotificationsNumber = 0;
        // Set the defaults
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#f34336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'tr',
                title: 'Turkish',
                flag: 'tr'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    async setAsRead(el) {
        this.loaderService.showLoader();
        const r: any = await this.notificationService.setRead(el.id).catch((err) => {
            console.error(err);
            this.loaderService.hideLoader();
        }).finally(() => {
            this.loaderService.hideLoader();
        });
        if (r) {
            if (r.ok) {
                await this.redirect(el);
            }
        }
    }

    async goToNotification(el) {

        const dialog = this.dialog.open(AlertComponentComponent, {
            data: {
                innerHTML: true,
                title: 'Attenzione',
                body: 'Stai per essere redirezionato alla pagina riferita alla notifica. Vuoi impostare la notifica come letta?',
                buttons: [
                    {
                        text: 'Si',
                        close: true,
                        value: true,
                        callback: async () => {
                            await this.setAsRead(el);
                        }
                    },
                    {
                        text: 'No',
                        close: true,
                        value: false,
                        callback: async () => {
                            await this.redirect(el);
                        }
                    }
                ]
            }
        });

    }

    async manageVideoCallNotification(el) {
        let config;
        if (this.localAccountService.isProfessor()) {
            config = {
                data: {
                    title: 'Comunicazione',
                    body: 'Stai per procedere alla video chiamata. Continuare?',
                    buttons: [
                        {
                            text: 'Si',
                            close: true,
                            value: true,
                            callback: async () => {
                                this.loaderService.showLoader();
                                const respo: any = await this.agendaService.startLesson(el.userSubjectAvailabilityId).finally(() => {
                                    this.loaderService.hideLoader();
                                });
                                if (respo) {
                                    if (respo.ok) {
                                        const op = respo.payload;
                                        this.eventsService.publishEvent({ event: 'clickOperator', op: op });
                                    }
                                }
                            }
                        },
                        {
                            text: 'No',
                            close: true,
                            value: false,
                            callback: async () => {

                            }
                        }
                    ]
                }
            };
        } else {
            config = {
                data: {
                    title: 'Comunicazione',
                    body: 'Attendi in linea la chiamata del docente',
                    buttons: [
                        {
                            text: 'Ok',
                            close: true,
                            value: true,
                            callback: async () => {

                            }
                        }
                    ]
                }
            };
        }
        this.dialog.open(AlertComponentComponent, config);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /* "CHANGE_PROFESSOR_REFUSE" */
    async redirect(el) {
        let url = null;
        switch (el.type) {
            case 'USER_DISPUTE_MESSAGE':
            case 'USER_REFUSE_DISPUTE_FROM_AGENDA':
            case 'USER_ACCEPT_DISPUTE_FROM_AGENDA':
            case 'CHANGE_PROFESSOR_NEW_PROPOSAL_ACCEPT': {
                url = this.primaryPath + this.secondaryPath + 'disputes/' + el.disputeId;
                break;
            }
            case 'CHANGE_MULTIPLE_AVAILABILITY':
            case 'CHANGE_SINGLE_AVAILABILITY':
            case 'CHANGE_PROFESSOR_REFUSE':
            case 'USER_VARIATION_PROPOSAL_ACCEPTED_MESSAGE':
            case 'USER_VARIATION_PROPOSAL_REFUSED_MESSAGE': {
                url = this.primaryPath + this.secondaryPath + 'communications/' + el.disputeId;
                break;
            }
            case 'USER_CONFIRM_COURSE_FROM_PROFESSOR':
            case 'USER_COURSE_NOT_AVAILABLE_ALREADY_PURCHASED':
            case 'USER_CONFIRM_PAYMENT':
            case 'USER_CONFIRM_COURSE_PURCHASE_STUDENT':
            case 'USER_RANKING': {
                url = this.primaryPath + 'student-courses';
                break;
            }
            case 'USER_PURCHASE_NEW_COURSE_FROM_STUDENT':
            case 'USER_PURCHASE_CANCELLED_BY_STUDENT':
            case 'USER_CONFIRM_COURSE_PURCHASE_PROFESSOR': {
                url = this.primaryPath + 'professor-teachings';
                break;
            }
            case 'USER_LESSON_START_ALERT': {
            }
        }
        if (url) {
            if (url === this.router.url) {
                location.reload(true);
            } else {
                this.router.navigateByUrl(url);
            }
        }
    }
    /**
     * On init
     */
    async ngOnInit() {

        try {
            if (this.auth.loggedIn()) {
                this.checkProfileButtonVisibility();
                if (this.localAccountService.isProfessor() || this.localAccountService.isStudent()) {
                    this.showVideoCallNotifications = true;
                }
                this.localAccountService.getAccount().then((account) => {
                    // console.log(account);
                    this.myUserUuid = account.userId;
                });
                this.subPollingSession = this.auth.refresh().subscribe();
                this.pollingInterval = setInterval(() => {
                    if (this.auth.loggedIn()) {
                        this.subPollingSession.unsubscribe();
                        this.subPollingSession = this.auth.refresh().subscribe();

                    }
                }, 450 * 1000);
                this.webSocketService.createWebSocket();
                this.listenOnEvents();
                this.listenOnWebSocketEvents();
                this.role = this.localAccountService.getRole();
                this.setPath(this.role);
            }
            // Subscribe to the config changes
            await this._fuseConfigService.config
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((settings) => {
                    this.horizontalNavbar = settings.layout.navbar.position === 'top';
                    this.rightNavbar = settings.layout.navbar.position === 'right';
                    this.hiddenNavbar = settings.layout.navbar.hidden === true;
                });
        } catch (ex) {
            // console.log(ex);
        }

    }

    ngAfterViewChecked() {
        this.checkProfileButtonVisibility();
    }

    checkProfileButtonVisibility() {
        if (window.location.href.includes('acceptances')) {
            this.showProfileButton = false;
        } else {
            this.showProfileButton = true;
        }
    }


    tryToPauseAudioAndNullify() {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }

    listenOnEvents() {
        if (!this.eventsSub) {
            this.eventsSub = this.eventsService.listenOnEvents().subscribe((msg) => {
                if (msg && msg.event) {
                    switch (msg.event) {
                        case 'toolbarVideocallStart':
                            this.videoCallContactId = msg.contactId;
                            // this.videoCallEmergencyId = msg.emergencyId;
                            this.videoCallOperatorContactId = null;
                            this.videoCallSocketSessionId = null;
                            this.videoCallOperatorIsAnswer = null;
                            this.videoCallId = null;
                            this.showVideoCall = true;
                            break;
                        case 'toolbarVideocallStop':
                            this.videoCallContactId = null;
                            this.videoCallEmergencyId = null;
                            this.videoCallOperatorContactId = null;
                            this.videoCallSocketSessionId = null;
                            this.videoCallOperatorIsAnswer = null;
                            this.videoCallId = null;
                            this.showVideoCall = false;

                            this.tryToPauseAudioAndNullify();
                            if (this.callingTimeout) {
                                clearTimeout(this.callingTimeout);
                                this.callingTimeout = null;
                            }

                            break;
                        case 'videocallTimeout':
                            this.tryToPauseAudioAndNullify();
                            this.videoCallContactId = null;
                            this.videoCallEmergencyId = null;
                            this.videoCallOperatorContactId = null;
                            this.videoCallSocketSessionId = null;
                            this.videoCallOperatorIsAnswer = null;
                            this.showVideoCall = false;
                            this.webSocketService.sendWebSocketMessage('call', 'timeout', { callId: this.callId });
                            this.userNotAvailable();
                            break;
                        case 'clickOperator':
                            if (this.showVideoCall) {
                                const dialog = this.dialog.open(AlertComponentComponent, {
                                    data: {
                                        innerHTML: true,
                                        title: 'Impossibile avviare la videochiamata',
                                        body: 'Per poter avviare un\'altra videochiamata e\' necessario terminare quella in corso',
                                        buttons: [
                                            {
                                                text: 'OK',
                                                close: true,
                                                value: true,
                                                callback: () => {
                                                    dialog.close();
                                                }
                                            }
                                        ]
                                    }
                                });
                            } else {
                                this._clickOperator(msg.op);
                            }
                            break;
                        case 'userNotAvailable2':
                            this.leaveCall(msg);
                            break;
                        // case 'askForNotes':
                        //     this.askForNotes(this._formBuilder, this.notificationService, data.emergencyId)
                        //         .then(
                        //             (dataNote) => {
                        //                 this.newSnackbar(`Nota chiusura creata.`, 'success');
                        //                 console.log('errNote: ', dataNote);

                        //             },
                        //             (errNote) => {
                        //                 this.newSnackbar(`Errore creazione nota chiusura.`, 'warn');
                        //                 console.log('errNote: ', errNote);
                        //             }
                        //         );
                        //     break;
                    }
                }
            });
        }
    }

    listenOnWebSocketEvents() {
        if (!this.eventsWebSocketSub) {
            this.eventsWebSocketSub = this.webSocketService.listenOnWebSocketReceivedMessages().subscribe((msg) => {
                if (msg && msg.event) {
                    switch (msg.event) {
                        case 'call':
                            if (msg.data.status === 'calling') {
                                // STO RICEVENDO UNA CHIAMATA... dovrei mostrare la modale
                                this.incomingCall(msg);
                            } else if (msg.data.status === 'leave') {
                                this.leaveCall(msg);
                            } else if (msg.data.status === 'answer') {
                                this.answerCall(msg);
                            } else if (msg.data.status === 'reject') {
                                this.rejectCall(msg);
                            }
                            break;
                        // case 'updateusers':
                        //     this.mergeOperators(msg.data);
                        //     break;
                        case 'updateNotifications':
                            this.updateNotifications(msg.data);
                            break;
                        // case 'updateemergencies':
                        //     this.updateEmergencies();
                        //     break;
                        // case 'updatenotification':
                        //     this.getNotifications();
                        //     break;
                        default:
                            break;
                    }
                }
            });
        }
    }

    updateNotifications(data) {
        this.buildNotifications(data.notifications);
    }

    xxx(e) {
        console.log(e);
    }

    userNotAvailable(): void {
        this.eventsService.publishEvent({
            event: 'CLOSECHAT'
        });
        this.callDialog = this.dialog.open(AlertComponentComponent, {
            // data: `${data}`,
            data: {
                innerHTML: true,
                title: 'Chiamata senza risposta',
                body: 'L\'utente non ha risposto alla chiamata.',
                buttons: [
                    {
                        text: 'OK',
                        close: true,
                        value: true,
                        callback: () => {
                            // this.router.navigateByUrl('/users-area/home');
                        }
                    }
                ]
            }

        });
        this.callDialog.afterClosed().toPromise();
    }

    incomingCall(msg) {
        this.userSubjectAvailabilityId = msg.data.userSubjectAvailabilityId;
        this.purchasedSalesPackageId = msg.data.purchasedSalesPackageId;
        const obj = {
            title: 'Chiamata in arrivo',
            body: 'Stai ricevendo una chiamata da ' + msg.data.fromCompleteName + ', cosa vuoi fare?',
            buttons: [
                {
                    text: 'Rispondi',
                    close: true,
                    color: 'accent',
                    hasIcon: true,
                    iconColor: '',
                    iconName: 'call',
                    callback: () => {
                        setTimeout(() => {
                            // tslint:disable-next-line:max-line-length
                            this.webSocketService.sendWebSocketMessage('call', 'answer', { 'toUserId': msg.data.from, 'callId': '' + msg.data.callId, userSubjectAvailabilityId: this.userSubjectAvailabilityId, purchasedSalesPackageId: this.purchasedSalesPackageId });
                            this.videoCallContactId = null;
                            this.videoCallOperatorContactId = msg.data.from;
                            this.videoCallSocketSessionId = msg.data.socketSessionFrom;
                            this.videoCallOperatorIsAnswer = 'true';
                            this.videoCallEmergencyId = null;
                            this.videoCallId = msg.data.callId;
                            this.showVideoCall = true;
                            this.eventsService.publishEvent({ event: 'INITIALIZE_CHAT', contactId: msg.data.from });
                        }, 10);
                        this.tryToPauseAudioAndNullify();
                        if (this.callingTimeout) {
                            clearTimeout(this.callingTimeout);
                            this.callingTimeout = null;
                        }
                    },
                    // closeDialog: true
                },
                {
                    text: 'Rifiuta',
                    color: 'warn',
                    hasIcon: true,
                    close: true,
                    value: msg,
                    iconColor: '',
                    iconName: 'call_end',
                    callback: (m) => {
                        this.tryToPauseAudioAndNullify();
                        this.rejectIncomingCall(m, false);
                    },
                    // closeDialog: true
                }],
            // changePassword: false,
            // textareas: null,
            // selects: null,
            // formGroup: null,
        };

        this.callDialog = this.dialog.open(AlertComponentComponent, {
            data: obj
        });

        this.audio = new Audio('assets/ring.mp3');
        this.audio.load();
        this.audio.loop = true;
        this.audio.play();

        this.callingTimeout = setTimeout(() => {
            this.rejectIncomingCall(msg, true);
        }, 30000);
    }

    leaveCall(msg) {
        this.userSubjectAvailabilityId = msg.data.userSubjectAvailabilityId;
        this.purchasedSalesPackageId = msg.data.purchasedSalesPackageId;
        this.eventsService.publishEvent({
            event: 'CLOSECHAT'
        });
        this.isCalling = false;
        if (this.callingTimeout) {
            clearTimeout(this.callingTimeout);
            this.callingTimeout = null;
        }
        this.tryToPauseAudioAndNullify();
        if (this.callDialog) {
            this.callDialog.close();
        }
    }

    answerCall(msg) {
        this.userSubjectAvailabilityId = msg.data.userSubjectAvailabilityId;
        this.purchasedSalesPackageId = msg.data.purchasedSalesPackageId;
        this.isCalling = false;
        this.tryToPauseAudioAndNullify();
    }

    rejectCall(msg) {
        setTimeout(() => {
            if (!this.isCalling) {
                return;
            }
            this.userSubjectAvailabilityId = msg.data.userSubjectAvailabilityId;
            this.purchasedSalesPackageId = msg.data.purchasedSalesPackageId;
            this.isCalling = false;
            this.videoCallContactId = null;
            this.videoCallOperatorContactId = null;
            this.videoCallSocketSessionId = null;
            this.videoCallOperatorIsAnswer = null;
            this.videoCallEmergencyId = null;
            this.videoCallId = null;
            this.showVideoCall = false;
            if (this.callingTimeout) {
                clearTimeout(this.callingTimeout);
                this.callingTimeout = null;
            }
            this.tryToPauseAudioAndNullify();
            this.audio = new Audio('assets/busy.mp3');
            this.audio.load();
            this.audio.loop = true;
            this.audio.play();
            setTimeout(() => {
                this.tryToPauseAudioAndNullify();
            }, 5000);
        }, 200);
    }

    rejectIncomingCall(msg, authomatic) {
        console.log('----------rejectCall----------');
        try {
            if (this.callDialog) {
                this.callDialog.close();
            }
        } catch (ex) {
            console.log('-------ex--------', ex);
        }

        try {
            this.tryToPauseAudioAndNullify();
        } catch (ex) {
            console.log('-------ex--------', ex);
        }

        this.webSocketService.sendWebSocketMessage('call', 'reject', {
            'toUserId': msg.data.from,
            'callId': msg.data.callId,
            userSubjectAvailabilityId: this.userSubjectAvailabilityId,
            purchasedSalesPackageId: this.purchasedSalesPackageId,
            authomaticRejection: authomatic
        });
        this.isCalling = false;
        this.videoCallContactId = null;
        this.videoCallOperatorContactId = null;
        this.videoCallSocketSessionId = null;
        this.videoCallOperatorIsAnswer = null;
        this.videoCallEmergencyId = null;
        this.videoCallId = null;
        this.showVideoCall = false;
    }

    buildNotifications(notifications) {
        let allVideoCallNotificationsNum = 0;
        let allOtherNotificationsNum = 0;
        const videoCallEnrichedNotifications = [];
        const allOtherEnrichedNotifications = [];
        if (notifications && notifications.length > 0) {
            for (let i = 0; i < notifications.length; i++) {
                const notification = notifications[i];
                if (!notification) {
                    continue;
                }
                if (notification && notification.type) {
                    const enrichedNotification = this.enrichNotification(notification);
                    if (notification.type === 'USER_LESSON_START_ALERT') {
                        allVideoCallNotificationsNum++;
                        videoCallEnrichedNotifications.push(enrichedNotification);
                    } else {
                        allOtherNotificationsNum++;
                        allOtherEnrichedNotifications.push(enrichedNotification);
                    }
                }
            }
        }
        this.videoCallNotifications = videoCallEnrichedNotifications;
        this.videoCallNotificationsNumber = allVideoCallNotificationsNum;
        this.notifications = allOtherEnrichedNotifications;
        this.notificationsNumber = allOtherNotificationsNum;
    }

    enrichNotification(notification) {
        const retNotification = notification;
        let icon, color, authorName;
        if (notification.author && notification.author.name && notification.author.surname) {
            authorName = notification.author.name + ' ' + notification.author.surname + ' - ';
        } else {
            authorName = '';
        }
        if (notification.type === 'USER_DISPUTE_MESSAGE') {
            icon = 'email';
            color = 'orange-800-fg';
        } else if (
            notification.type === 'USER_VARIATION_PROPOSAL_ACCEPTED_MESSAGE' ||
            notification.type === 'USER_CONFIRM_COURSE_PURCHASE_STUDENT' ||
            notification.type === 'USER_CONFIRM_COURSE_PURCHASE_PROFESSOR' ||
            notification.type === 'USER_CONFIRM_COURSE_FROM_PROFESSOR'
        ) {
            icon = 'check';
            color = 'green-800-fg';
        } else if (notification.type === 'USER_PURCHASE_NEW_COURSE_FROM_STUDENT') {
            icon = 'import_contacts';
            color = 'fuse-black-fg';
        } else if (
            notification.type === 'USER_PURCHASE_CANCELLED_BY_STUDENT' ||
            notification.type === 'USER_VARIATION_PROPOSAL_REFUSED_MESSAGE' ||
            notification.type === 'USER_COURSE_NOT_AVAILABLE_ALREADY_PURCHASED'
        ) {
            icon = 'close';
            color = 'warn-800-fg';
        } else if (
            notification.type === 'USER_CONFIRM_PAYMENT'
        ) {
            icon = 'euro_symbol';
            color = 'green-800-fg';
        } else if (
            notification.type === 'CHANGE_MULTIPLE_AVAILABILITY' ||
            notification.type === 'CHANGE_SINGLE_AVAILABILITY'
        ) {
            icon = 'warning';
            color = 'warn-800-fg';
        } else if (notification.type === 'USER_RANKING') {
            icon = 'star';
            color = 'green-800-fg';
        } else if (notification.type === 'USER_LESSON_START_ALERT') {
            icon = 'access_alarms';
            color = 'warn-800-fg';
        } else {
            icon = 'warning';
            color = 'warn-800-fg';
        }
        retNotification.icon = icon;
        retNotification.color = color;
        retNotification.authorName = authorName;
        return retNotification;
    }

    setPath(role) {
        if (role === 'STUDENT') {
            this.primaryPath = '/users-area/';
            this.secondaryPath = 'student-';
        } else if (role === 'PROFESSOR') {
            this.secondaryPath = 'professor-';
            this.primaryPath = '/users-area/';
        } else if (role === 'ADMINISTRATOR' || role === 'OPERATOR') {
            this.secondaryPath = 'admin-';
            this.primaryPath = '/administration-area/';
        }
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        if (this.subPollingSession) {
            this.subPollingSession.unsubscribe();
        }
        if (this.auth.loggedIn()) {
            if (this.pollingInterval !== null) {
                clearInterval(this.pollingInterval);
            }
        }
        if (this.eventsSub) {
            this.eventsSub.unsubscribe();
        }
        if (this.eventsWebSocketSub) {
            this.eventsWebSocketSub.unsubscribe();
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }


    /**
     * Logout
     *
     * @param value
     */
    async logout() {
        this.loaderService.showLoader();
        const isProfessor = this.localAccountService.isProfessor();
        const isStudent = this.localAccountService.isStudent();
        await this.auth.logOut().then(async (res: any) => {
            await this.localAccountService.logout();
            this.webSocketService.closeSocket();
            if (isProfessor || isStudent) {
                if (res.payload.redirectToWordpressAfterLogout) {
                    // setTimeout(() => {
                    window.open(res.payload.redirectUrl, '_self');
                    // }, 1000);
                } else {
                    if (isProfessor) {
                        this.router.navigateByUrl('/public-area/redirect?fromPage=professorLogin');
                    } else {
                        this.router.navigateByUrl('/public-area/redirect?fromPage=studentLogin');
                    }
                    this.loaderService.hideLoader();
                }
            } else {
                this.router.navigateByUrl('/public-area/redirect?backofficeLogin');
                this.loaderService.hideLoader();
            }

        })
            // .catch((err) => {
            //     console.error(err);
            // })
            .finally(() => {
                this.loaderService.hideLoader();
            });

    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
        console.log(value);
    }

    async openProfile() {
        this.router.navigateByUrl('/common-area/myProfile');
        /* await this.localAccountService.getAccount().then((res: any) => {
            this.data = res;
        });
        const dialog = this.dialog.open(ProfileComponent, {
            width: '400px',
            panelClass: 'custom-panel-class',
            data: {
                data: this.localAccountService.getAccount(),
                banks: this.bankService.getBanks(-1, -1, null)
            }
        }); */
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
    }

    // clickOperator(userId) {
    //     const op = this.operators.find(x => x.userId === userId);
    //     this._clickOperator(op);
    // }



    // _clickOperator(op) {
    //     if (!op) {
    //         this.alertRedirectToEmergency();
    //         return;
    //     }
    //     if (this.isCalling) {
    //         return;
    //     }
    //     // console.log('click operator', op);
    //     if (op.sessionId && op.status === 'ONLINE') {
    //         this.isCalling = true;
    //         this.videoCallContactId = null;
    //         this.videoCallOperatorContactId = op.userId;
    //         this.videoCallSocketSessionId = op.sessionId;
    //         this.videoCallOperatorIsAnswer = 'false';
    //         this.videoCallEmergencyId = null;
    //         this.videoCallId = null;
    //         this.showVideoCall = true;
    //         // this.audio = new Audio('assets/ringback.mp3');
    //         // this.audio.load();
    //         // this.audio.loop = true;
    //         // this.audio.play();
    //     } else {
    //         this.alertRedirectToEmergency();
    //     }
    // }



    _clickOperator(op) {
        // if (!op) {
        //     this.alertRedirectToEmergency();
        //     return;
        // }
        // if (this.isCalling) {
        //     return;
        // }
        // console.log('click operator', op);
        // if (op.sessionId && op.status === 'ONLINE') {
        this.eventsService.publishEvent({ event: 'INITIALIZE_CHAT', contactId: op.userId });
        this.isCalling = true;
        this.videoCallContactId = null;
        this.videoCallOperatorContactId = op.userId;
        this.videoCallSocketSessionId = op.sessionId;
        this.userSubjectAvailabilityId = op.userSubjectAvailabilityId;
        this.purchasedSalesPackageId = op.purchasedSalesPackageId;
        this.videoCallOperatorIsAnswer = 'false';
        this.videoCallEmergencyId = null;
        this.videoCallId = null;
        this.showVideoCall = true;
        this.audio = new Audio('assets/ringback.mp3');
        this.audio.load();
        this.audio.loop = true;
        this.audio.play();
        // } else {
        //     this.alertRedirectToEmergency();
        // }
    }

    alertRedirectToEmergency(): void {
        const dialog = this.dialog.open(AlertComponentComponent, {
            // data: `${data}`,
            data: {
                innerHTML: true,
                title: 'Attenzione',
                body: 'L\'utente al momento non &egrave; disponibile.',
                buttons: [
                    {
                        text: 'OK',
                        close: true,
                        value: true,
                        callback: () => {
                            dialog.afterClosed().toPromise();
                        }
                    }
                ]
            }

        });
    }

    mergeOperators(payload: []) {
        let toRemove = [];
        for (let index = 0; index < this.operators.length; index++) {
            const element = this.operators[index];
            const found = payload.find((v) => {
                return v['userId'] === element.userId;
            });
            if (!found) {
                toRemove.push(index);
            } else {
                this.operators[index].status = found['status'];
                this.operators[index].sessionId = found['sessionId'];
            }
        }
        toRemove = toRemove.sort((a, b) => {
            if (a === b) {
                return 0;
            }
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
        });

        for (let index = toRemove.length - 1; index >= 0; index--) {
            this.operators.splice(toRemove[index], 1);
        }

        for (let index = 0; index < payload.length; index++) {
            if (payload[index]['userId'] === this.myUserUuid) {
                continue;
            }
            const found = this.operators.find((v) => {
                return v['userId'] === payload[index]['userId'];
            });
            if (!found) {
                this.operators.push(payload[index]);
            }
        }
    }

}
